import DayGroup from "../../automation/DayGroup";
import React, { useCallback } from "react";
import DelayControl from "../../automation/DelayControl";
import { Logger } from '../../../utils/logger';
import "../../automation/automation.css";

interface ActionData {
  type: string;
  data: any;
}

interface IBotAutomationSection {
  isUpdateAuto: boolean;
  taskData: any;
  dayActions: Record<string, ActionData[]>;
  setDayActions: any;
  ShowInfoAction: any;
  setDayDelays: any;
  statusData: any;
  userListData: any;
  labelData: any;
  leadListData: any;
  whatsappTemplate: any;
  emailTemplate: any;
  dayErrors: any;
  dayDelays: any;
  dayMetrics?: Record<string, any>;
}

const BotAutomationSection = ({
  isUpdateAuto,
  taskData,
  dayActions,
  setDayActions,
  ShowInfoAction,
  setDayDelays,
  statusData,
  userListData,
  labelData,
  leadListData,
  whatsappTemplate,
  emailTemplate,
  dayErrors,
  dayDelays,
  dayMetrics,
}: IBotAutomationSection) => {
  const handleAddAction = (dayKey: string) => {
    const newActions = {
      ...dayActions,
      [dayKey]: [...(dayActions[dayKey] || []), { type: "", data: {} }],
    };
    setDayActions(newActions);
  };

  const handleActionChange = (
    dayKey: string,
    actionIndex: number,
    value: string
  ) => {
    const newActions = { ...dayActions };
    if (newActions[dayKey]) {
      newActions[dayKey] = newActions[dayKey].map(
        (action: any, idx: number) =>
          idx === actionIndex ? { ...action, type: value, data: {} } : action
      );
    }
    setDayActions(newActions);
  };

  const handleActionDelete = (dayKey: string, actionIndex: number) => {
    const newActions = {
      ...dayActions,
      [dayKey]: dayActions[dayKey].filter(
        (_: any, idx: number) => idx !== actionIndex
      ),
    };
    setDayActions(newActions);
  };

  const handleDeleteDay = useCallback((dayKey: string) => {
    const newActions = { ...dayActions };
    delete newActions[dayKey];
    setDayActions(newActions);

    const newDelays = { ...dayDelays };
    delete newDelays[dayKey];
    setDayDelays(newDelays);
  }, [dayActions, dayDelays, setDayActions, setDayDelays]);

  const handleAddDay = () => {
    const days = Object.keys(dayActions);

    let lastDayNumber = 0;

    if (days?.length) {
      lastDayNumber = Math.max(
        ...days.map((day) => parseInt(day.split("_")[1]))
      );
    }

    const newDayKey = `day_${lastDayNumber + 1}`;

    const newActions = {
      ...dayActions,
      [newDayKey]: [],
    };
    setDayActions(newActions);

    const newDelays = {
      ...dayDelays,
      [newDayKey]: 1,
    };
    setDayDelays(newDelays);
  };

  const handleDelayChange = (
    dayKey: string,
    newDelay: number,
    index: number
  ) => {
    if (index < Object.keys(dayActions)?.length - 2) {
      return;
    }

    const newDelays = {
      ...dayDelays,
      [dayKey]: newDelay,
    };
    setDayDelays(newDelays);

    let tempDelays = { ...dayDelays, [dayKey]: newDelay };

    const sortedDays = Object.keys(dayActions).sort(
      (a, b) => parseInt(a.split("_")[1]) - parseInt(b.split("_")[1])
    );

    if (sortedDays.length === 0) return;

    let currentDayNumber = 1;

    const newDayActions: Record<string, any> = {};

    sortedDays.forEach((dayKey, index) => {
      newDayActions[`day_${currentDayNumber}`] = dayActions[dayKey];

      if (index < sortedDays.length - 1) {
        let delayKey = tempDelays[dayKey] || 1;
        currentDayNumber += delayKey;
      }
    });

    setDayActions(newDayActions);
  };

  return (
    <div className="col-md-12 when_then">
      <span className="auto_dot">
        <label className="dot_no">3</label>
      </span>
      <label className="when_then_label">Automation Actions</label>
      <span className="when_then_trigger">
        Add actions to execute automatically after bot completion
      </span>

     {/* Day Groups */}
{Object.entries(dayActions)
  .sort(
    ([a], [b]) => parseInt(a.split("_")[1]) - parseInt(b.split("_")[1])
  )
  .map(([dayKey, actions], index, arr) => {
    return (
      <React.Fragment key={dayKey}>
        <DayGroup
          key={dayKey}
          dayKey={dayKey}
          actions={dayActions[dayKey]}
          onAddAction={handleAddAction}
          onActionChange={handleActionChange}
          onActionDelete={handleActionDelete}
          onShowActionInfo={(value) => {
            ShowInfoAction(value, dayKey);
          }}
          onDeleteDay={handleDeleteDay}
          isUpdateAuto={isUpdateAuto}
          statusData={statusData}
          userListData={userListData}
          labelData={labelData}
          leadListData={leadListData}
          whatsappTemplate={whatsappTemplate}
          emailTemplate={emailTemplate}
          taskData={taskData}
          errors={dayErrors[dayKey]}
          isDelete={Object.keys(dayActions).length > 1}
          metrics={dayMetrics && dayMetrics[dayKey]}
        />

        {index < Object.keys(dayActions).length - 1 && (
          <DelayControl
            value={dayDelays[dayKey] || 1}
            onChange={(value) => handleDelayChange(dayKey, value, index)}
            error={dayErrors[dayKey]?.delay}
          />
        )}
      </React.Fragment>
    );
  })}

      {/* Add Day Button */}
      <div className="add_new_plus mt-4" onClick={handleAddDay}>
        <span className="auto_dot_plus">
          <img alt="plus" src="assets/img/plus.png" />
        </span>
        <label>ADD DAY</label>
      </div>
    </div>
  );
};

export default BotAutomationSection;